import { Box, Stack, styled } from "@mui/material";
import { FC } from "react";

import { ButtonNew, TButtonNewVariant } from "@/modules/irohana-components/elements/ButtonNew";
import { divider } from "@/modules/irohana-components/theme/colors-new";

export type TDialogFooterProps = {
  cancelLabel?: string;
  confirmLabel?: string;
  confirmVariant?: TButtonNewVariant;
  onCancel?: () => void;
  onConfirm?: () => void;
  isLoading?: boolean;
  disabledConfirm?: boolean;
  /** Hide individual buttons depending on the situation. */
  hideCancel?: boolean;
  hideConfirm?: boolean;
  /** Optional auxiliary action rendered on the left side. */
  tertiaryLabel?: string;
  onTertiary?: () => void;
  isLoadingTertiary?: boolean;
};

export const DialogFooter: FC<TDialogFooterProps> = ({
  cancelLabel = "キャンセル",
  confirmLabel = "確認",
  confirmVariant = "primary",
  onCancel,
  onConfirm,
  isLoading,
  disabledConfirm,
  hideCancel,
  hideConfirm,
  tertiaryLabel,
  onTertiary,
  isLoadingTertiary,
}) => {
  return (
    <FooterRow>
      <Box>
        {tertiaryLabel && (
          <ButtonNew size="sm" variant="tertiary" onClick={onTertiary} isLoading={isLoadingTertiary}>
            {tertiaryLabel}
          </ButtonNew>
        )}
      </Box>
      <Stack direction="row" gap="12px" alignItems="center">
        {!hideCancel && (
          <ButtonNew size="sm" variant="secondary" onClick={onCancel}>
            {cancelLabel}
          </ButtonNew>
        )}
        {!hideConfirm && (
          <ButtonNew size="sm" variant={confirmVariant} onClick={onConfirm} isLoading={isLoading} disabled={disabledConfirm}>
            {confirmLabel}
          </ButtonNew>
        )}
      </Stack>
    </FooterRow>
  );
};

const FooterRow = styled(Stack)({
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  gap: "12px",
  padding: "16px 24px",
  borderTop: `1px solid ${divider.middle}`,
});
